export { isFunction, debounce, noop, identity, throttle } from 'lodash-es'

// Public: Wraps an async function, and returns a promise that will only be
// resolved or rejected for the promise returned by the last function call.
//
// Helpful for cases where only the last function call matters, and any previous
// calls should be ignored.
export function ignorePreviousCalls<I extends any[], T extends Promise<any>> (
  promiseReturningFunc: (...args: I) => T,
): (...args: I) => T {
  let lastPromise: T
  return (...args: I) => new Promise((resolve, reject) => {
    const promise = lastPromise = promiseReturningFunc(...args)
    promise.finally(() => {
      if (promise === lastPromise) promise.then(resolve, reject)
    })
  }) as T
}
